module.exports = __webpack_public_path__ + "static/matricula-consular-8b5f77c6c2765862e018106ae7d67e34.svg";